/* ------------------------------------------------------
Button Controller
------------------------------------------------------ */

// In theory this function will look for new buttons being added to the page inside of p tags, and make them all the same width grouped by their parent element
// Seems to be working, let's wait until I am proven wrong :)

const selector = 'p .button, input[type="submit"]';
Watcher.observe(selector, elements => {
  const parents = [];

  // Loop the elements array
  elements.forEach(element => {
    // Find the parent element (the p tag)
    let p = element.parentNode;
    // Find the parent of the p tag
    let parent = p.parentNode;

    // While p is not a p tag, keep going up the tree
    while (p.tagName !== 'P' && p.tagName !== 'BODY') {
      // Set the p tag to the parent
      p = parent;
      // Set the parent to the parent of the parent
      parent = p.parentNode;
    }

    // If the parent is not already in the parents array, add it
    if (!parents.includes(parent)) parents.push(parent);
  });

  // Loop the parents array
  parents.forEach(parent => {
    // Find all the .buttons inside of p tags
    const buttons = parent.querySelectorAll(selector);

    // Now that we are here, we want all buttons to be the same width (the width of the widest button)
    // We need to create a resize observer to watch the parent element for changes

    // Create a new ResizeObserver
    const Observer = new ResizeObserver(() => {
      // Loop the buttons and remove the width and white space
      buttons.forEach(button => {
        button.style.width = '';
        button.style.whiteSpace = '';
      });

      // Get the width of the widest button
      const width = Math.max(...Array.from(buttons).map(button => button.clientWidth));
      // Set up a max width
      let maxWidth = null;

      // Loop through the buttons
      buttons.forEach(button => {
        let directParent = button.parentNode;
        // Loop up the tree until we find a width that is not 0
        while (directParent.clientWidth === 0) directParent = directParent.parentNode;

        // If this button is wider than it's own parent, set the max width to 100%
        if (button.clientWidth > directParent.clientWidth) maxWidth = '100%';
      });
      if (maxWidth) {
        return buttons.forEach(button => {
          // Set the width to 100%
          button.style.width = '100%';
          // Set the white space to normal
          button.style.whiteSpace = 'normal';
        });
      } else {
        // Loop the buttons and set the width
        buttons.forEach(button => button.style.width = `${width}px`);
      }
    });

    // Start observing the parent element
    Observer.observe(parent);
  });
});